module.exports = __webpack_public_path__ + "img/img15.b1eaa80a.svg";